import { useTranslation } from 'react-i18next'
import { HelpCenterTranslations } from '@/HelpCenter/ui/helpCenterTranslations'
import { useHelpCenter } from '@/HelpCenter/ui/context/HelpCenterContext'
import {
    OreRadioButton,
    OreStack,
    OreText
} from '@edenredespana/oreneta'

export const NewTicketStep2 = (): JSX.Element => {
    const { t } = useTranslation()
    const { selectedReasonDetails, form } = useHelpCenter()
    const selectedDetailId = form.watch('caseReasonDetailId')

    return (
        <OreStack space="medium" placeContent="stretch">
            <OreStack space="xsmall" placeContent="stretch">
                <OreText size="text-lg" bold>{t(HelpCenterTranslations.step2.title)}</OreText>
                <OreText>{t(HelpCenterTranslations.step2.subtitle)}</OreText>
            </OreStack>
            <OreStack space="small" placeContent="stretch">
                {selectedReasonDetails?.map((detail) => (
                    <OreRadioButton
                        key={detail.caseReasonDetailId}
                        label={detail.descriptionWeb}
                        name="caseReasonDetailId"
                        value={String(detail.caseReasonDetailId)}
                        checked={selectedDetailId === detail.caseReasonDetailId}
                        onChange={() => form.setValue('caseReasonDetailId', detail.caseReasonDetailId, { shouldValidate: true })}
                    />
                ))}
            </OreStack>
        </OreStack>
    )
}


